import {AttributeChangeRequest} from 'src/openapi/models/AttributeChangeRequest';
import {EventChangeRequest} from 'src/openapi/models/EventChangeRequest';
import {FieldType} from 'src/openapi/models/FieldType';
import {ItemsType} from 'src/openapi/models/ItemsType';

export enum FieldName {
    ID = 'id',
    ATTRIBUTE_ID = 'attributeId',
    REQUIRED = 'required',
    EVENT_ID = 'eventId',
    NAME = 'name',
    DESCRIPTION = 'description',
    FIELD_TYPE = 'fieldType',
    ITEMS_TYPE = 'itemsType',
    POSSIBLE_VALUES = 'possibleValues',
    DEPRECATED = 'deprecated',
    CONTEXTUAL_LINK_TITLE = 'ContextualLinkTitle',
    CONTEXTUAL_LINK_VALUE = 'ContextualLinkValue',
    ATTRIBUTE_LAST_USAGE_DATE = 'attributeLastUsageDate',
}

export type CreationAttribute = {
    [FieldName.ID]?: string,
    [FieldName.ATTRIBUTE_ID]?: string,
    [FieldName.EVENT_ID]?: number,
    [FieldName.REQUIRED]: boolean,
    [FieldName.NAME]: string,
    [FieldName.DESCRIPTION]: string | null,
    [FieldName.FIELD_TYPE]: string | FieldType,
    [FieldName.ITEMS_TYPE]?: string | ItemsType,
    [FieldName.POSSIBLE_VALUES]: string[],
    [FieldName.DEPRECATED]: boolean,
};

export enum UpdateChangeRequestType {
    HEADER = 'header',
    ATTRIBUTES = 'attributes',
}

export type HeaderBlock = Omit<EventChangeRequest, 'attributes'>;
export type UpdateChangeRequest = HeaderBlock | AttributeChangeRequest[];
